export default __webpack_public_path__ + "static/media/img-1.1f2c4ca7.jpg";